import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  userProfileStatus: null,
  userData: null,
  subscribedData: null,
  categories:[],
  user: [],
  savedCards: [],
  recentWorks:[],
  error: "", // for error message
  loading: false,
  paymentProvider:"",
  isUserLogout: false,
  spinnerLoading:false,
  errorMsg: false, // for error
};

const userProfileSlice = createSlice({
  name: "userProfile",
  initialState,
  reducers: {
    apiError(state, action) {
      // state.error = action.payload;
      // state.loading = true;
      // state.isUserLogout = false;
      // state.errorMsg = true;
    },
    setSpinnerLoading (state,action){
state.spinnerLoading= action.payload
    },
    setPaymentProvider (state,action){
      state.paymentProvider= action.payload
          },
    setSavedCards (state,action){
      state.savedCards= action.payload
          },
    userProfile(state, action) {
      state.userProfileStatus = action.payload
      state.loading = false;
      state.errorMsg = false;
    },
    userdataSuccess(state, action) {
      state.userData = action.payload
      state.loading = false;
      state.errorMsg = false;
    },
    userSuccess(state, action) {
      state.user = action.payload
      state.loading = false;
      state.errorMsg = false;
    },
    userSubscribedSuccess(state, action) {
      state.subscribedData = action.payload
      state.loading = false;
      state.errorMsg = false;
    },
     allCategories(state, action) {
      state.categories = action.payload.result
      state.loading = false;
      state.errorMsg = false;
    },
    recentWork(state, action) {
      state.recentWorks = action.payload.result
      state.loading = false;
      state.errorMsg = false;
    }, 
  },
});

export const {
  apiError,
  userProfile,
  userdataSuccess,
  userSuccess,
  userSubscribedSuccess,
  allCategories,setSavedCards,
  recentWork,setSpinnerLoading,setPaymentProvider
} = userProfileSlice.actions
export const selectSpinerLoading =(state:any)=> state.UserProfile.spinnerLoading
export const selectSavedCards =(state:any)=> state.UserProfile.savedCards
export const selectUserDetails = (state:any)=> state.UserProfile.user
export const selectPaymentProvider = (state:any)=> state.UserProfile.paymentProvider
export default userProfileSlice.reducer;